<!-- 首营供货商列表 -->
<template>
    <div class='page_content'>
        <el-drawer :close-on-press-escape="true" :visible.sync="showStatus" :with-header="false" append-to-bodycustom-class="drawer_box" direction="ltr" size="100%">
            <supplierCommonAction v-if="showStatus" ref="supplierCommonAction" @drawerCancel="drawerCancel" :actionData="actionData"></supplierCommonAction>
        </el-drawer>
        <div class="page_content_top">
            <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getPageInfo" @openFormDesign="openFormDesign"></v-button>
            <div class="page_content_top_line">
                <v-search v-if="pageShowData.jurHead" :searchList="pageShowData.jurHead.jurconfigform" :getRequestData="getRequestData" @searchData="searchData" @openSearch="openSearch">

                </v-search>

            </div>
        </div>
        <div class="page_content_center">
            <div class="left" :style="{height: tableHeight+'px'}" v-if="isMenu">
                <el-menu :default-active="activeMenu" :key="'menu-' + menuList.length" class="el-menu-vertical-demo" @select="handleMenuSelect">
                    <el-menu-item index="all">
                        <i class="el-icon-menu"></i>
                        <span slot="title">全部</span>
                    </el-menu-item>
                    <el-menu-item v-for="item in menuList" :key="item.codeId" :index="String(item.codeId)">
                        <i class="el-icon-document"></i>
                        <span slot="title">{{ item.codeType }}</span>
                    </el-menu-item>
                </el-menu>
            </div>
            <div class="right" :class="{ 'right-full': !isMenu }">
                <el-table align="center" @selection-change="handleSelectionChange" v-if="pageShowData.jurTableVo" stripe :data="returnData.list" :height="tableHeight" :key="$store.state.tableNum" border style="width: 100%"
                          highlight-current-row size="mini">
                    <el-table-column type="selection" width="55"></el-table-column>
                    <!-- 主表单 -->
                    <template v-for="(tableValye, tableKey) in pageShowData.jurTableVo.jurconfigtable">
                        <el-table-column align="center" v-if="tableValye.isShow == 1" :key="tableKey" :prop="tableValye.entityField" :label="tableValye.showField" show-overflow-tooltip :min-width="tableValye.fieldWeight">
                            <template slot-scope="scope">
                                <span v-if="tableValye.fieldType == 'date' && scope.row[tableValye.entityField]">
                                    {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                                </span>
                                <span v-else-if="tableValye.fieldType == 'dateTime' && scope.row[tableValye.entityField]">
                                    {{ $common.getLocalTime(scope.row[tableValye.entityField], true) }}
                                </span>
                                <span v-else-if="tableValye.entityField == 'smState'">{{ scope.row.smState == 0 ? '停用' :
                                '启用' }}</span>
                                <!-- 状态判断 -->
                                <el-tag v-else-if="tableValye.entityField == 'gsmState'" size="mini">
                                    {{ $common.getIsGsp(tableValye.formatterContent, scope.row.gsmState) }}</el-tag>
                                <!-- 成立日期 -->
                                <span v-else-if="tableValye.isRift == 1">
                                    <a @click="toDetail(scope.row[tableValye.riftField])">{{ scope.row[tableValye.entityField] }}</a>
                                </span>
                                <span v-else>{{ scope.row[tableValye.entityField] }}</span>
                            </template>
                        </el-table-column>
                    </template>
                </el-table>
            </div>
        </div>
        <div class="page_content_bottom">
            <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total" @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>
        </div>
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
            <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
        </el-dialog>
        <!-- 自定义设计 -->
        <customDesign ref="customDesign"></customDesign>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import { provinceAndCityData, regionData, provinceAndCityDataPlus, regionDataPlus, CodeToText, TextToCode } from 'element-china-area-data'
import supplierCommonAction from "@/components/supplierCommonAction.vue"
console.log(regionData);
export default {
    //import引入的组件需要注入到对象中才能使用
    components: {
        supplierCommonAction,
    },
    data() {
        //这里存放数据
        return {
            tableHeight: 0,
            getRequestData: {
                smName: "",
                smHemcode: "",
                page: 1,
                rows: 30,
                smIntype: "",
                smIntype: ""
            },
            returnData: {
                pages: 0, // 总页数
                total: 0, // 总条数
                pageNum: 0, // 当前页数
                list: [],
            },
            buttonList: [],
            pageShowData: [], //列表数据
            selectData: [],
            formDataList: [],
            imgUrl: '', //图片显示根路径
            showStatus: false,
            actionData: [],
            DialogVisible: false,
            parentSearchData: {},
            seTitle: "",
            seWidth: "",
            ocrResults: [],
            formShow: false,
            menuList: [],
            activeMenu: "all",
            isMenu: false,
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
        handleSelectionChange(val) {
            this.selectData = val
        },
        //检索方案
        openSearch({ sId, index, type, sField }) {
            this.DialogVisible = true;
            this.seId = sId;
            this.sField = sField;
            this.parentSearchData[type] = this.getRequestData[type];
        },
        //检索带回数据
        changeInputModel(val) {

            if (val != "" || val != undefined) {
                this.DialogVisible = false;
                this.paramValue(val);
            }
        },
        // 赋值字段
        paramValue(val) {
            console.log(val, this.sField)
            let arr = this.sField.split(",");
            arr.forEach((item) => {
                this.getRequestData[item] = val[item];
            });
        },
        getSeWidth(e) {
            console.log(e);
            this.seWidth = e + "%";
        },
        getSearchName(e) {
            console.log(e);
            this.seTitle = e;
        },
        // 子组件触发
        drawerCancel(commitData) {
            this.showStatus = false
            commitData && this.getDataList()
        },
        // 点击穿透字段 传参单号
        toDetail(orderId) {
            if (orderId) {
                // 设置为true 打开穿透组件首页    
                var isPenetrate = true
                // 设置缓存 存入点击单号
                this.resetSetItem('penetrateOrderId', orderId);
                // 与父级跨域通信 传递isPenetrate参数
                window.parent.postMessage({ //向窗口发送MessageEvent消息
                    cmd: 'returnFormJson',
                    params: {
                        isPenetrate
                    } //参数
                },
                    '*');
            }
        },
        toSalesman() {
            var pagePath = '/salesmanList'
            // 与父级跨域通信 传递isPenetrate参数
            window.parent.postMessage( //向窗口发送MessageEvent消息
                {
                    cmd: 'toOtherPage',
                    params: {
                        pagePath
                    }
                },
                '*');
        },
        //图片地址转换
        pictureShow(data) {
            var imgList = [];
            data.forEach((item) => {
                imgList.push(this.imgUrl + '/' + item.fileUrl);
            });
            return imgList;
        },

        isShowData(name, value) {
            this.getRequestData[name] = value;
        },
        // 获取数据列表
        async getPageInfo() {
            var pathId = parent.getMenuInfo(this.$route.path);
            let responseData = await this.$http.getJur({
                ids: [pathId.jurId]
            });
            if (responseData.status == 200) {
                this.getButtonList()
                this.pageShowData = responseData.result;
                this.formDataList = this.pageShowData.jurFormVoList
                var obj = {}
                if (this.pageShowData.jurHead) {
                    obj = this.$common.getSearchData(this.pageShowData.jurHead.jurconfigform, 'page', "rows", 30)
                } else {
                    obj = this.$common.getSearch(this.getRequestData, 'start', 'end', 'page', 'rows', 30)
                }
                for (const key in obj) {
                    this.$set(this.getRequestData, key, obj[key])
                }
                if (this.formShow) {
                    if (this.pageShowData.jurFormVoList&&this.pageShowData.jurFormVoList.length>0) {
                        if (!this.showStatus) {
                            this.$nextTick(() => {
                                this.actionData = {
                                    cate: 0,
                                    formData: this.pageShowData.jurFormVoList,
                                    oldData: "",
                                    orderId: "",
                                    printSouce: "",
                                    printJurId: "",
                                    fatherType: 'GSP',
                                    ocrResults: this.ocrResults
                                };
                                this.formShow = false
                                this.showStatus = true;
                            })
                        }
                    }
                }
                await this.getMenuData()
                this.getDataList()
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        // 左侧菜单切换
        handleMenuSelect(codeId) {
            this.activeMenu = String(codeId)
            if (codeId === 'all') {
                this.$set(this.getRequestData, 'codeType', '')
            } else {
                const menuItem = this.menuList.find(item => String(item.codeId) === String(codeId))
                if (!menuItem) return
                this.$set(this.getRequestData, 'codeType', menuItem.codeType)
            }
            this.getRequestData.page = 1
            this.getDataList()
        },
        // 检查并处理OCR识别结果
        checkOCRResult(event) {
            console.log(event.data, "测试");
            if (event.data.type == 'OCR_message') {
                if (event.data.data) {
                    this.ocrResults = event.data.data
                    if (this.pageShowData.jurFormVoList&&this.pageShowData.jurFormVoList.length>0) {
                        if (!this.showStatus) {
                            this.$nextTick(() => {
                                this.actionData = {
                                    cate: 0,
                                    formData: this.pageShowData.jurFormVoList,
                                    oldData: "",
                                    orderId: "",
                                    printSouce: "",
                                    printJurId: "",
                                    fatherType: 'GSP',
                                    ocrResults: this.ocrResults
                                };
                                this.formShow = false
                                this.showStatus = true;
                            })
                        }
                    } else {
                        this.formShow = true
                    }

                }
            }
        },
        // 动作集合
        actionSet(actionData) {
            switch (actionData.actionType) {
                case 0: //新增
                    this.showStatus = true
                    this.actionData = {
                        cate: 0,
                        formData: this.formDataList,
                        oldData: '',
                        orderId: '',
                        printSouce: '',
                        printJurId: '',
                        fatherType: 'GSP'
                    }
                    break;
                case 1: //修改
                    this.openDataActionBox(actionData.actionType);
                    break;
                case 2: //删除
                    this.delDataAction();
                    break;
                case 3: //提交
                    this.submitData()
                    break;
                case 4: //业务员
                    this.toSalesman()
                    break;
                case 15:
                    this.openFormDesign()
                    break;
            }
        },
        openFormDesign() {
            let pathInfo = parent.getMenuInfo(this.$route.path)
            this.$refs['customDesign'].openBox(pathInfo.jurId, this.pageShowData, pathInfo.jurName)
        },
        // 数据搜索
        searchData() {
            this.getRequestData.page = 1;
            this.getDataList();
        },
        // 数据翻页
        setDataPageNumber(val) {
            this.getRequestData.page = val;
            this.getDataList();
        },

        // 切换显示条数
        setDataPageSize(val) {
            this.getRequestData.page = 1;
            this.getRequestData.rows = val;
            this.getDataList();
        },
        openDataActionBox(cate) {
            if (cate == 0) {
                this.showStatus = true
                this.actionData = {
                    cate: 0,
                    formData: this.formDataList,
                    oldData: '',
                    orderId: '',
                    printSouce: '',
                    printJurId: '',
                    fatherType: 'GSP'
                }
            } else {
                if (this.returnData.list.length <= 0) {
                    this.$message({
                        message: "暂无数据",
                        type: "error",
                    });
                    return false;
                }
                if (this.selectData.length != 1) {
                    this.$message({
                        message: "请先选择您要操作的一条数据",
                        type: "error",
                    });
                    return false;
                }
                var olddataInfo = this.selectData[0]
                let dataInfo
                this.$http.queryFirstSupplier({
                    ids: [olddataInfo.gsmId]
                }).then(res => {
                    if (res.status == 200) {
                        dataInfo = res.result
                        this.showStatus = true;
                        this.actionData = {
                            cate: 1,
                            formData: this.formDataList,
                            oldData: dataInfo,
                            orderId: dataInfo.gsmId,
                            printSouce: '',
                            printJurId: '',
                            fatherType: 'GSP'
                        }
                    } else {
                        this.$message.error(res.message)
                    }
                })


            }
        },

        // 获取数据列表
        async getDataList() {
            // console.log(this.getRequestData);
            let responseData = await this.$http.getFirstSupplierList(
                this.getRequestData
            );
            if (responseData.status == 200) {
                this.returnData.list = responseData.result.list;
                this.returnData.pages = responseData.result.pages;
                this.returnData.total = responseData.result.total;
                this.returnData.pageNum = responseData.result.pageNum;
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        async getMenuData() {
            const params = { codeClassify: 1 }
            const res = await this.$http.getQueryCodeClassify(params)
            if (res.status == 200) {
                this.menuList = res.result || []
            } else {
                this.menuList = []
            }
            this.activeMenu = "all"
            this.$set(this.getRequestData, 'codeType', '')
        },
        // 首营供货商提交供货商
        submitData() {
            if (this.returnData.list.length <= 0) {
                this.$message({
                    message: "暂无数据",
                    type: "error",
                });
                return false;
            }
            if (this.selectData.length == 0) {
                this.$message({
                    message: "请先选择您要操作的数据",
                    type: "error",
                });
                return false;
            }
            this.$confirm("确定要提交供货商吗？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(async () => {
                    var delData = {
                        ids: this.selectData.map(item => item.gsmId),
                    };
                    let responseData = await this.$http.submitFirstSupplier(delData);
                    if (responseData.status == 200) {
                        this.$message({
                            type: "success",
                            message: "操作成功!",
                        })
                        this.getDataList();
                    } else {
                        this.$message({
                            message: responseData.message,
                            type: "error",
                        });
                    }
                })
                .catch(() => { });
        },

        // 删除数据
        delDataAction() {
            if (this.returnData.list.length <= 0) {
                this.$message({
                    message: "暂无数据",
                    type: "error",
                });
                return false;
            }
            if (this.selectData.length != 1) {
                this.$message({
                    message: "请先选择您要操作的一条数据",
                    type: "error",
                });
                return false;
            }
            var dataInfo = this.selectData[0]

            this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(async () => {
                    var delData = {
                        ids: [dataInfo.gsmId],
                    };
                    let responseData = await this.$http.delFirstSupplier(delData);
                    if (responseData.status == 200) {
                        this.$message({
                            type: "success",
                            message: "删除成功!",
                        });

                        this.getDataList();
                    } else {
                        this.$message({
                            message: responseData.message,
                            type: "error",
                        });
                    }
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除",
                    });
                })
                .catch(() => { });
        },

        // 获取按钮权限
        async getButtonList() {
            this.buttonList = await this.$common.getActionButton()
            
        },
//获取状态
        getIsGsp(str, val) {
            try {
                let arr = JSON.parse(str);
                let len = arr.length;
                let newStr = "";
                for (let i = 0; i < len; i++) {
                    if (arr[i].key === val) {
                        newStr = arr[i].value;
                        break;
                    }
                }
                return newStr;
            } catch (ex) {
                return str;
            }
        },

    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.getPageInfo();
        this.imgUrl = this.$store.getters.getConfig.imgUrl;
        this.isMenu = window.global_config.isLeftMenuBgm || false
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() { window.addEventListener('message', this.checkOCRResult); },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { this.tableHeight = this.$common.getTableHeight() }, //生命周期 - 更新之后
    beforeDestroy() { window.removeEventListener('message', this.checkOCRResult); }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
    deactivated() { window.removeEventListener('message', this.checkOCRResult); },
};
</script>

<style scoped>
.table_content_tag {
    margin-right: 1rem;
}

.el-tabs--border-card_new {
    height: 85vh;
    overflow-y: scroll;
}

.page_content_center {
    display: flex;
    justify-content: space-between;
}

.left {
    flex-shrink: 0;
    overflow-y: auto;
    overflow-x: hidden;
    width: 150px;
}

.el-menu-vertical-demo {
    width: 150px;
    border-right: none;
}

.right {
    flex: 1;
    min-width: 0;
    width: calc(100% - 160px);
}

.right-full {
    width: 100%;
}

::v-deep .el-menu-item {
    height: 36px;
    line-height: 36px;
}
</style>